define("shared/utils/download-csv", ["exports", "shared/utils/redirect"], function (_exports, _redirect) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.downloadCSV = _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"shared/utils/redirect"eaimeta@70e063a35619d71f
  const downloadCSV = (rows, fileName) => {
    const CSVContent = _generateCSV(rows);
    const fileMetaData = 'text/csv;encoding:utf-8';
    _download(CSVContent, fileName, fileMetaData);
  };

  // Note: From https://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side
  _exports.downloadCSV = downloadCSV;
  const _download = (content, fileName, mimeType) => {
    const anchorElement = document.createElement('a');
    if (navigator && navigator.msSaveBlob) {
      // IE10
      navigator.msSaveBlob(_createNewBlob(content, mimeType), fileName);
    } else if (URL && 'download' in anchorElement) {
      // HTML5
      anchorElement.href = URL.createObjectURL(_createNewBlob(content, mimeType));
      anchorElement.setAttribute('download', fileName);
      document.body.appendChild(anchorElement);
      anchorElement.click();
      document.body.removeChild(anchorElement);
    } else {
      // Only this mime type is supported
      (0, _redirect.default)(`data:application/octet-stream,${encodeURIComponent(content)}`);
    }
  };
  const _generateCSV = rows => rows.reduce((table, row) => {
    const newLine = '\r\n';
    const isEmptyRow = row === '\n';
    const newTable = isEmptyRow ? table : table + row.join(',');
    return newTable + newLine;
  }, '');
  const _createNewBlob = function (content) {
    let mimeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'application/octet-stream';
    return (
      // Note: Use UTF-8 BOM to fix excel import. See https://stackoverflow.com/questions/1241220/generating-csv-file-for-excel-how-to-have-a-newline-inside-a-value
      new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), content], {
        type: mimeType
      })
    );
  };
  var _default = _exports.default = {
    downloadCSV
  };
});